import { render, staticRenderFns } from "./batch-disbursement-reference-detail.vue?vue&type=template&id=2b075f17&scoped=true"
import script from "./batch-disbursement-reference-detail.vue?vue&type=script&lang=js"
export * from "./batch-disbursement-reference-detail.vue?vue&type=script&lang=js"
import style0 from "./batch-disbursement-reference-detail.vue?vue&type=style&index=0&id=2b075f17&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b075f17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b075f17')) {
      api.createRecord('2b075f17', component.options)
    } else {
      api.reload('2b075f17', component.options)
    }
    module.hot.accept("./batch-disbursement-reference-detail.vue?vue&type=template&id=2b075f17&scoped=true", function () {
      api.rerender('2b075f17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/batch-disbursement-reference-detail.vue"
export default component.exports